import * as React from 'react';

import { ConceptExplanation, FeedbackForm } from '../../index';

export interface ConceptFeedbackData {
  translatedDescription?: string;
  [key: string]: any;
}

export interface ConceptsFeedbackState {
  data: {
    [key: string]: ConceptFeedbackData;
  };
  states: {
    [key: string]: string;
  };
}

export interface ConceptsState {
  data: {
    [key: string]: any[];
  };
  hasreceiveddata: boolean;
}

export interface Match {
  params: {
    conceptFeedbackID: string;
  };
}

interface ConceptFeedbackProps {
  basePath?: string;
  concepts: ConceptsState;
  conceptsFeedback: ConceptsFeedbackState;
  containerClassName?: string;
  editingStateConstant: string;
  match: Match;
  onCancelEdit?: (feedbackID: string) => void;
  onDeleteConceptsFeedback?: (feedbackID: string) => void;
  onStartEdit?: (feedbackID: string) => void;
  onSubmitNewFeedback?: (feedbackID: string, data: any) => void;
  showTranslation?: boolean;
}

interface ConceptFeedbackComponentState {
  translated: boolean;
}

export class ConceptFeedback extends React.Component<
  ConceptFeedbackProps,
  ConceptFeedbackComponentState
> {
  constructor(props: ConceptFeedbackProps) {
    super(props);
    this.state = { translated: false };
  }

  handleCancelEdit = (feedbackID: string) => {
    const { onCancelEdit } = this.props;
    if (onCancelEdit) {
      onCancelEdit(feedbackID);
    }
  };

  handleDeleteConceptsFeedback = () => {
    const { match, onDeleteConceptsFeedback } = this.props;
    const { params } = match;
    const { conceptFeedbackID } = params;

    if (
      onDeleteConceptsFeedback &&
      confirm("⚠️ Are you sure you'd like to delete this concept feedback?")
    ) {
      onDeleteConceptsFeedback(conceptFeedbackID);
    }
  };

  handleSubmitNewFeedback = (feedbackID: string, data: any) => {
    const { onSubmitNewFeedback } = this.props;
    if (onSubmitNewFeedback) {
      onSubmitNewFeedback(feedbackID, data);
    }
  };

  handleToggleEdit = () => {
    const { match, onStartEdit } = this.props;
    const { params } = match;
    const { conceptFeedbackID } = params;

    if (onStartEdit) {
      onStartEdit(conceptFeedbackID);
    }
  };

  toggleTranslation = () => {
    this.setState((prevState) => ({
      translated: !prevState.translated,
    }));
  };

  renderTranslationButton = (data: ConceptFeedbackData) => {
    const { showTranslation } = this.props;
    const { translated } = this.state;

    if (showTranslation && data.translatedDescription) {
      const buttonText = translated ? 'Hide translation' : 'Show translation';
      return (
        <button
          className="button is-info"
          id="toggle-translation"
          onClick={this.toggleTranslation}
          type="button"
        >
          {buttonText}
        </button>
      );
    }
    return null;
  };

  getConcept = () => {
    const { concepts, match } = this.props;
    const { params } = match;
    const { conceptFeedbackID } = params;

    if (!concepts.hasreceiveddata) {
      return null;
    }

    const dataArray = concepts.data[0] || concepts.data['0'];
    if (!dataArray) {
      return null;
    }

    return dataArray.find((c: any) => c.uid === conceptFeedbackID);
  };

  render() {
    const {
      concepts,
      conceptsFeedback,
      containerClassName = '',
      editingStateConstant,
      match,
    } = this.props;
    const { data, states } = conceptsFeedback;
    const { hasreceiveddata } = concepts;
    const { params } = match;
    const { conceptFeedbackID } = params;
    const { translated } = this.state;

    const concept = this.getConcept();
    const conceptName = concept ? (
      <h4 className="title">{concept.displayName}</h4>
    ) : null;

    if (data && conceptFeedbackID && data[conceptFeedbackID]) {
      const isEditing = states[conceptFeedbackID] === editingStateConstant;

      if (isEditing) {
        return (
          <div className={containerClassName} key={conceptFeedbackID}>
            {conceptName}
            <FeedbackForm
              {...data[conceptFeedbackID]}
              cancelEdit={this.handleCancelEdit}
              conceptFeedbackID={conceptFeedbackID}
              submitNewFeedback={this.handleSubmitNewFeedback}
            />
          </div>
        );
      }

      return (
        <div className={containerClassName} key={conceptFeedbackID}>
          {conceptName}
          <ConceptExplanation
            {...data[conceptFeedbackID]}
            adminShowTranslation={translated}
          />
          <p className="concept-feedback-control">
            <button
              className="button is-info"
              onClick={this.handleToggleEdit}
              type="button"
            >
              Edit Feedback
            </button>
            <button
              className="button is-danger"
              onClick={this.handleDeleteConceptsFeedback}
              type="button"
            >
              Delete Concept Feedback
            </button>
            {this.renderTranslationButton(data[conceptFeedbackID])}
          </p>
        </div>
      );
    }

    if (hasreceiveddata === false) {
      return <p>Loading...</p>;
    }

    if (conceptFeedbackID) {
      return (
        <div className={containerClassName} key={conceptFeedbackID}>
          {conceptName}
          <FeedbackForm
            cancelEdit={this.handleCancelEdit}
            conceptFeedbackID={conceptFeedbackID}
            submitNewFeedback={this.handleSubmitNewFeedback}
          />
        </div>
      );
    }

    return <p>We could not find this concept.</p>;
  }
}
